module.exports = [{
      plugin: require('/mnt/h/42WebCode/everglows.com/gatsby-starter-eventually-master/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
